import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { Context } from '../index';
import { BASKET_ROUTE } from '../utils/consts';
import { FaShoppingCart } from 'react-icons/fa';
import { observer } from 'mobx-react-lite';

const FloatingCartButton = observer(() => {
    const { user } = useContext(Context);
    const navigate = useNavigate();
    const location = useLocation();

    const cartCount = Array.isArray(user.basket)
        ? user.basket.reduce((sum, item) => sum + (item.quantity || 1), 0)
        : 0;

    const isOnBasketPage = location.pathname === BASKET_ROUTE;

    if (cartCount <= 0 || isOnBasketPage) {
        return null;
    }

    return (
        <div className="floating-cart-button-wrapper" aria-live="polite">
            <Button
                variant="primary"
                className="floating-cart-button"
                onClick={() => navigate(BASKET_ROUTE)}
                aria-label={`Перейти в корзину, товаров: ${cartCount}`}
            >
                <FaShoppingCart className="me-2" />
                <span className="floating-cart-button__text">Корзина</span>
                <span className="floating-cart-button__badge">{cartCount}</span>
            </Button>
        </div>
    );
});

export default FloatingCartButton;

